import { restApi } from '../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { query, paginate } from '../../lib/loopback'

const transportadoraConfiavelRepository = createRepository({
  path: 'transportadoras-confiavel',
  restApi,
  queryTransform: {
    nome: query.ilike('nome'),
    ...paginate
  }
})
export default transportadoraConfiavelRepository
